import { mergeStatusChain } from '../utils/mergeMessageStatus';
import mergeMessage from '../utils/mergeMessage';

// Apollo skips the type-level merge for messages written inside a list, so the chain rule also
// lives on the field; mergeMessage is what decides when a failure may be left behind.
const messageTypePolicy = {
  merge: mergeMessage,
  fields: {
    status: {
      merge: mergeStatusChain,
    },
  },
};

export default messageTypePolicy;
